import { Tag } from "antd";

export function Status({ status, color = 'blue'}){
    return <Tag color={color}>{status}</Tag>
}